module.exports = __webpack_public_path__ + "static/media/bootstrap.760f4e7c.png";